import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import { emptyError } from '../../../../../../src/components/common/validation/validation-utils';
import Login from '../../../../../../src/screens/user/login/login';
import { TermsConditions, SignUp, PdfContent } from '../../../../../../src/screens/modal-content';
import LogoutConfirmModal from '../../../../../../src/screens/auth/logout/logout-confirm-modal';
import MobileWebLanding from '../../mobile-web-landing';
import { isMobile, isChrome, isSafari, isFirefox, isMobileSafari, isOpera, isTablet, isAndroid } from 'react-device-detect';
import Logout from '../../auth/logout';
import ForgotPasswordPage from '../../../screens/auth/forgot-password';
import { CHANNEL_TYPES } from '../../../../../../src/constants';
import TermsConditionLUX from '../../../../../../src/screens/modal-content/lux-modals-for-login';
import { EBANKINGWEBLUX } from '../../../constants';
import envConfig from '../../../../../../db-env-build';
import { LoginCircle } from '../../../../../../src/components/common/icons';

const jose = require('node-jose');

class LoginContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.cryptoPass = undefined;
  }

  state = {
    isModalActive: false,
    userId: undefined,
    password: undefined,
    userIdEmpty: undefined,
    passwordEmpty: undefined,
    showUserPopover: false,
    showPasswordPopover: false,
    showForgotPasswordPage: false
  };

  componentWillMount() {
    this.props.loginTerms.onGetPdf();
    this.props.languages.getlanguages();
    // this.props.changeshowchangepassword(false);
    this.props.resetPasswordExpired(false);
  }

  componentDidMount() {
    this.addEventHandlerForPopover();
    this.props.platform.detectBrowser();
    this.props.setAuthorised(false);
  }

  componentWillUnmount() {
    this.props.auth.setErrorMsg('');
    this.removeEventHandlerForPopover();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.auth.cryptoEncryptedObjSuccess) {
      this.props.auth.setCryptoEncryptedObjSuccess(false);
      this.doLogin(newProps);
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.vascoauthentication.otpVerified !== this.props.vascoauthentication.otpVerified) {
  //     this.handleForgotPasswordPage();
  //   }
  // }

  handleEnterPress = (ev) => {
    const userId = document.getElementById("loginUserNameSelection").value;
    const password = document.getElementById("loginPasswordSelection").value;
    if (ev.key === "Enter" && userId && password) {
      this.handleLogin(userId, password);
    }
  }

  modalContent() {
    const { modalContentType } = this.state;

    switch (modalContentType) {
      case 'legal':
        {
          envConfig.envConfig === EBANKINGWEBLUX ?
          <TermsConditionLUX modalContentType="TnC For LUX" /> :
          <TermsConditions />;
        }
      case 'sign-up':
        return <SignUp />;
      case 'faq':
        return <PdfContent modalContentType="faq" />;
      case 'security':
        return <PdfContent modalContentType="security" />;
      case 'olduser':
        return <TermsConditionLUX modalContentType="olduser" />;
      case 'New e-banking client':
        return <TermsConditionLUX modalContentType="New e-banking client" />
      default:
        return <View />;
    }
  }

  doLogin(newProps) {
    const { userId, password } = this.state;
    const { i18n: { messages } } = this.props;
    const globalAuth = newProps.auth;
    const { token, modulus, exponent, seskey, keyType } = globalAuth.cryptoEncryptedObj;
    const randnr = '';
    const pubkey = '';

    const d = new Date();
    const issueTimeNow = d.getTime();
    const expiry = (d.getTime() + 1000 * 60 * 10);
    const jwtIDRan = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

    const ergonEncryptionPayload = {
      iss: 'https://openid.net',
      sub: 'alice',
      aud: ['https://app-one.com', 'https://app-two.com'],
      exp: expiry,
      iat: issueTimeNow,
      nbf: issueTimeNow,
      jti: jwtIDRan,
      password,
    };

    const publicKey = {
      'kty': keyType,
      'alg': 'RSA-OAEP-256',
      'enc': 'A128GCM',
      'n': modulus,
      'e': exponent,
    };

    jose.JWK.asKey(publicKey).
      then((result) => {

        jose.JWE.createEncrypt({ format: 'compact', contentAlg: 'A128GCM', fields: { nonce: token } }, result.toJSON()).
          update(jose.util.asBuffer(JSON.stringify(ergonEncryptionPayload))).
          final().
          then((jwe) => {
            const data = jwe.replace(/\./g, '*');
            globalAuth.onGlobalAuthLogin({
              userId,
              password,
              data,
              token,
              randnr,
              pubkey,
              seskey,
            });
          }).catch((err) => {
            if (err) {
              globalAuth.setInvalidLogin(true);
              globalAuth.setErrorMsg(messages['app.auth.unableToConnect']);
              globalAuth.setLoginBusy(false);
            }
          });
      });


  }

  handleShowUserPopover = () => {
    if (this.state.showPasswordPopover) {
      this.setState((currentState) => ({
        showPasswordPopover: !currentState.showPasswordPopover,
        showUserPopover: !currentState.showUserPopover
      }));
    }
    else {
      this.setState((currentState) => ({ showUserPopover: !currentState.showUserPopover }));
    }
  };

  handleShowPasswordPopover = () => {
    if (this.state.showUserPopover) {
      this.setState((currentState) => ({
        showPasswordPopover: !currentState.showPasswordPopover,
        showUserPopover: !currentState.showUserPopover
      }));
    }
    else {
      this.setState((currentState) => ({ showPasswordPopover: !currentState.showPasswordPopover }));
    }
  };

  handleTextFieldEnterPress = () => {
    if (this.state.showUserPopover !== false || this.state.showUserPopover !== false) {
      this.setState({
        showUserPopover: false,
        showPasswordPopover: false
      });
    }

  }

  addEventHandlerForPopover = () => {
    document.addEventListener('click', this.closePopovers);
  }

  removeEventHandlerForPopover = () => {
    document.removeEventListener('click', this.closePopovers);
  }

  closePopovers = (ev) => {
    const childPopover = ev.target && ev.target.querySelectorAll('div.popover');
    if (childPopover.length > 0) {
      this.setState({
        showUserPopover: false,
        showPasswordPopover: false
      });
    };
  }

  handleLogin = (userId, password) => {
    const { type = 'login' } = this.state;
    this.setState({
      userId,
      password
    });
    this.props.auth.globalAuthEncryptionKey({ userId, type });

  };

  validate() {
    const { userId, password } = this.state;
    const userIdEmpty = emptyError(userId, false);
    const passwordEmpty = emptyError(password, false);

    this.setState({
      userIdEmpty,
      passwordEmpty,
    });

    const valid = !userIdEmpty && !passwordEmpty;
    console.log('valid', valid);
    return valid;
  }

  toggleModal = (pageType) =>
    this.setState({
      isModalActive: !this.state.modalActive,
      modalContentType: pageType,
    });

  hideModal = () => {
    this.setState(() => ({
      isModalActive: false,
      isMainContainerViewAccessible: false,
      showForgotPasswordPage: false
    }));
  };

  hideForgotPwdModal = (isForgotPasswordPage, resetAllVariables) => {
    const { resetcode: { resetVariables } } = this.props;
    this.setState(() => ({
      isModalActive: false,
      isMainContainerViewAccessible: false,
      showForgotPasswordPage: false
    }));
    // this.props.resetcode.setShowForgotPasswordPage(false);
    if (isForgotPasswordPage === true) {
      this.props.auth.logout();
    }
    if (resetAllVariables === true) {
      resetVariables();
    }
  };

  // handleSetupNewPassword = () => {
  //   this.props.changePage('/new-user-change-password');
  // }

  handleForgotPasswordPage = () => {

  }
  handleSetupNewPassword = () => {
    const { forgotPassword: { resetVariables } } = this.props;
    // this.setState(() => ({
    //   showForgotPasswordPage: true,
    // }));
    resetVariables();
    this.props.changePage('/forgot-password');
  };

  render() {

    if ((isMobile || isTablet) && (isChrome || isFirefox || isMobileSafari || isSafari || isOpera || isAndroid)) {
      return (<MobileWebLanding />);
    }
    const { auth: { loginBusy } } = this.props;
    const { showForgotPasswordPage } = this.state;

    return (

      <View className="login">
        <LoginCircle className="login-env-logo" />
        <Login
          {...this.props}
          isLoginBusy={loginBusy}
          onInputChanged={this.handleInputChanged}
          onLogin={this.handleLogin}
          handleShowPasswordPopover={this.handleShowPasswordPopover}
          handleShowUserPopover={this.handleShowUserPopover}
          showUserPopover={this.state.showUserPopover}
          showPasswordPopover={this.state.showPasswordPopover}
          handleSetupNewPassword={this.handleSetupNewPassword}
          handleEnterPress={this.handleEnterPress}
          handleTextFieldEnterPress={this.handleTextFieldEnterPress}
          handleForgotPasswordPage={this.handleForgotPasswordPage}
          appChannel={CHANNEL_TYPES.WEB}
          destLanguage={this.props.languages.destLanguage}
          destLanguageCode={this.props.languages.destLanguageCode}
        >
          {this.props.children}
        </Login>
        <LogoutConfirmModal />
      </View>
    );
  }
}

LoginContainer.propTypes = {
  auth: PropTypes.shape({
    onValidateDevice: PropTypes.func,
    plannedServerDowntimeCheck: PropTypes.func,
    onGlobalAuthLogin: PropTypes.func,
  }),
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    auth: {
      channel: true,
      loginBusy: true,
      isVisitedLinkActive: true,
      errorMsg: true,
      cryptoEncryptedObj: true,
      globalAuthEncryptionKey: { $call: 'getGlobalAuthEncryptionKey' },
      onGlobalAuthLogin: { $call: 'globalauthlogin' },
      cryptoEncryptedObjSuccess: true,
      setCryptoEncryptedObjSuccess: { $set: 'cryptoEncryptedObjSuccess' },
      setInvalidLogin: { $set: 'invalidLogin' },
      setLoginBusy: { $set: 'loginBusy' },
      setErrorMsg: { $set: 'errorMsg' },
      setVisitedLinkActive: {$set: 'isVisitedLinkActive' },
      isWso2Down: true
    },
    languages: {
      saveLanguageAtLogin: { $call: 'saveLanguageAtLogin' },
      getlanguages: { $call: 'getlanguages' },
      destLanguage: true,
      destLanguageCode: true,
    },
    setAuthorised: { $call: 'auth.setAuthorised' },
    changePage: { $call: 'ui.history.push' },
    platform: {
      detectBrowser: { $call: 'initBrowser' },
    },
    loginTerms: {
      onGetPdf: { $call: 'getPdfLink' },
      pdfLinkData: true,
    },
    i18n: {
      messages: true,
    },
    app: {
      config: {
        showchangepassword: true,
        labelAccessibilityInfoEnglish: true,
        labelAccessibilityInfoGerman: true,
      }
    },
    changeshowchangepassword: { $set: 'app.config.showchangepassword' },
    resetPasswordExpired: { $set: 'auth.passwordExpired' },
    forgotPassword: {
      resetVariables: { $call: 'resetVariables' },
      //  setShowForgotPasswordPage: { $set: 'forgotPasswordPage' }
    },
    banner:{
      plannedDowntime: true,
      activeDowntime: true,
      isDowntime: true
    }
  },
})(LoginContainer);
